import { Component } from '@angular/core';

@Component({
  selector: 'app-faq-master',
  templateUrl: './faq-master.component.html',
  styleUrls: ['./faq-master.component.css'],
})
export class FaqMasterComponent {
  title1 = 'Admin Panel';
  title3 = 'My Article';
  title = 'FAQ <span>Master</span>';
  class1 = 'profile-banner ';
  img1 = '../../../assets/images/logo.png';
}
